import type { IComponentController, IScope } from "angular";
import { finalize } from "rxjs/operators";

import type { IProfileService } from "App/Modules/Auth/Services/Profile/IProfileService";
import type { ICompany, IResponseWithLoading } from "App/Modules/Models";
import type { ICompaniesRepository } from "App/Modules/Repositories";
import type { IModalService, IPageService } from "App/Modules/Services";
import { addLoading } from "App/Modules/Services";

import { get, size } from "lodash";
import { extendWithLoadingAndFail } from "App/Modules/Services/ObservableExtensions";

export default class CompaniesComponentController implements IComponentController {
    public static $inject: string[] = [
        "$scope",
        "mmCompaniesRepository",
        "irPageService",
        "mmProfileService",
        "mmModalService",
    ];

    public companies: IResponseWithLoading<ICompany[]>;

    public companiesFilter: string;

    constructor(
        private readonly $scope: IScope,
        private readonly companiesRepository: ICompaniesRepository,
        private readonly pageService: IPageService,
        private readonly profileService: IProfileService,
        private readonly modalService: IModalService,
    ) {}

    public $onInit() {
        extendWithLoadingAndFail(this.companiesRepository.getAllCompanies())
            .pipe(
                addLoading(this.pageService),
                finalize(() => this.$scope.$applyAsync()),
            )
            .subscribe(
                (companies: IResponseWithLoading<ICompany[]>) => {
                    this.companies = companies;
                },
                (error: IResponseWithLoading<null>) => {
                    this.companies = error;
                },
            );
    }

    public shouldShowPartner(): boolean {
        return size(get(this.profileService.getProfileIfAvailable(), "partners")) > 1;
    }

    public addCompany() {
        this.modalService.open<ICompany, null>("irAddCompany", null).subscribe(
            (company: ICompany) => {
                this.companies.data.push(company);
            },
            (error) => error,
        );
    }
}
